/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino } from './PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino';
import {
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAinoFromJSON,
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAinoFromJSONTyped,
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAinoToJSON,
} from './PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino';
import type { PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant } from './PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant';
import {
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantFromJSON,
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantFromJSONTyped,
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantToJSON,
} from './PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant';
import type { PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi } from './PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi';
import {
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiFromJSON,
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiFromJSONTyped,
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiToJSON,
} from './PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi';
import type { PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant } from './PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant';
import {
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistantFromJSON,
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistantFromJSONTyped,
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistantToJSON,
} from './PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant';
import type { PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoe } from './PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoe';
import {
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoeFromJSON,
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoeFromJSONTyped,
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoeToJSON,
} from './PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoe';
import type { PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch } from './PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch';
import {
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitchFromJSON,
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitchFromJSONTyped,
  PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitchToJSON,
} from './PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch';

/**
 * @type PatchedSingleTurnChatInferencerPolymorphic
 *
 * @export
 */
export type PatchedSingleTurnChatInferencerPolymorphic =
  | ({ protocol: 'AINO' } & PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino)
  | ({
      protocol: 'AZURE_OPEN_AI_ASSISTANT';
    } & PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant)
  | ({ protocol: 'CUSTOM_API' } & PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi)
  | ({
      protocol: 'OPEN_AI_ASSISTANT';
    } & PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant)
  | ({ protocol: 'POE' } & PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoe)
  | ({ protocol: 'SPITCH' } & PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitch);

export function PatchedSingleTurnChatInferencerPolymorphicFromJSON(
  json: any,
): PatchedSingleTurnChatInferencerPolymorphic {
  return PatchedSingleTurnChatInferencerPolymorphicFromJSONTyped(json, false);
}

export function PatchedSingleTurnChatInferencerPolymorphicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedSingleTurnChatInferencerPolymorphic {
  if (json == null) {
    return json;
  }
  switch (json['protocol']) {
    case 'AINO':
      return Object.assign(
        {},
        PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAinoFromJSONTyped(json, true),
        { protocol: 'AINO' } as const,
      );
    case 'AZURE_OPEN_AI_ASSISTANT':
      return Object.assign(
        {},
        PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantFromJSONTyped(json, true),
        { protocol: 'AZURE_OPEN_AI_ASSISTANT' } as const,
      );
    case 'CUSTOM_API':
      return Object.assign(
        {},
        PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiFromJSONTyped(json, true),
        { protocol: 'CUSTOM_API' } as const,
      );
    case 'OPEN_AI_ASSISTANT':
      return Object.assign(
        {},
        PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistantFromJSONTyped(json, true),
        { protocol: 'OPEN_AI_ASSISTANT' } as const,
      );
    case 'POE':
      return Object.assign(
        {},
        PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoeFromJSONTyped(json, true),
        { protocol: 'POE' } as const,
      );
    case 'SPITCH':
      return Object.assign(
        {},
        PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitchFromJSONTyped(json, true),
        { protocol: 'SPITCH' } as const,
      );
    default:
      throw new Error(
        `No variant of PatchedSingleTurnChatInferencerPolymorphic exists with 'protocol=${json['protocol']}'`,
      );
  }
}

export function PatchedSingleTurnChatInferencerPolymorphicToJSON(
  value?: PatchedSingleTurnChatInferencerPolymorphic | null,
): any {
  if (value == null) {
    return value;
  }
  switch (value['protocol']) {
    case 'AINO':
      return PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAinoToJSON(value);
    case 'AZURE_OPEN_AI_ASSISTANT':
      return PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantToJSON(value);
    case 'CUSTOM_API':
      return PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiToJSON(value);
    case 'OPEN_AI_ASSISTANT':
      return PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistantToJSON(value);
    case 'POE':
      return PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerPoeToJSON(value);
    case 'SPITCH':
      return PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerSpitchToJSON(value);
    default:
      throw new Error(
        `No variant of PatchedSingleTurnChatInferencerPolymorphic exists with 'protocol=${value['protocol']}'`,
      );
  }
}
